<span class="fa-stack w-100" role="button" (click)="onClick()" (keydown.enter)="onClick()"
	(keydown.space)="$event.preventDefault(); onClick()" [class.allow]="rightStatuses[rightFlag] > 0"
	[class.deny]="rightStatuses[rightFlag] < 0" [class.effective-neutral]="rightStatuses[rightFlag] === 0"
	[class.toggle-disabled]="readonly" [title]="description" [attr.aria-label]="description + ': ' + statusLabel"
	[attr.aria-disabled]="readonly" [attr.tabindex]="readonly ? -1 : 0" data-cy="clickSecurityPolicyCell">
	<i [hidden]="rightStatuses[rightFlag] === 0" class="fal fa-stack-1x" aria-hidden="true"></i>
</span>